import { useSetupNativeAVEvents } from './useSetupNativeAVEvents';

export const SetupNativeAVEvents = (): null => {
  useSetupNativeAVEvents();
  return null;
};
